(() => {
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function initDropSection(section) {
    if (!section || section.dataset.lootDropReady === 'true') return;
    section.dataset.lootDropReady = 'true';

    const sectionId = section.id.replace('LootDropSection-', '');
    const drawer = document.getElementById(`LootDropDrawer-${sectionId}`);
    if (!drawer) return;

    const panel = drawer.querySelector('.loot-drop-panel');
    const openers = document.querySelectorAll(`[aria-controls="${drawer.id}"]`);
    const closers = drawer.querySelectorAll('[data-loot-drop-close]');
    let lastFocus = null;

    const setExpanded = (value) => openers.forEach((opener) => opener.setAttribute('aria-expanded', String(value)));

    const open = () => {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('loot-drop-locked');
      setExpanded(true);
      window.setTimeout(() => panel?.focus(), 60);
    };

    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('loot-drop-locked');
      setExpanded(false);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    openers.forEach((opener) => opener.addEventListener('click', open));
    closers.forEach((closer) => closer.addEventListener('click', close));

    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll(focusableSelector)].filter((el) => el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add('is-drop-ready');
            observer.disconnect();
          }
        });
      }, { threshold: 0.28 });
      observer.observe(section);
    } else {
      section.classList.add('is-drop-ready');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-loot-drop-section]').forEach(initDropSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
